import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=5ccebeb8&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UploadFile.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&media=screen&href=assets%2Fvendor%2Fsamples.css"
if (typeof block0 === 'function') block0(component)

export default component.exports